export const getters = {
  catalog: (state) => state.catalog,
  loading: (state) => state.loading,
  loaded: (state) => state.loaded,
  error: (state) => state.error,

  /**
   * Read a nested section by dotted path, e.g. `section("storage.s3.backup")`.
   * Returns undefined instead of throwing when the API has not shipped that
   * section (yet), so pages can degrade to "not available" rather than crash.
   */
  section: (state) => (path) =>
    String(path)
      .split(".")
      .reduce((node, key) => (node ? node[key] : undefined), state.catalog),
};
